<app-add-form
  [title]="title"
  [formFields]="formFields"
  [loading]="loading"
  [initialData]="initialData"
  [editMode]="true"
  [headerActions]="headerActions"
  (formAction)="onFormAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
></app-add-form>
